import { defineMessages } from 'react-intl';

export default defineMessages({
	trendingTitle: {
		id: 'app.searchBar.trendingTitle',
		defaultMessage: 'Trending',
		description: 'Trending searches title',
	},
	recentsTitle: {
		id: 'app.searchBar.recentsTitle',
		defaultMessage: 'Recent',
		description: 'Recent searches title',
	},
});
